import React from "react";
import { useParams } from "react-router-dom";

import RobotSearchFiles from "../features/robot/RobotSearchFiles";
import RobotSearchFilesOld from "../features/robot/RobotSearchFilesOld";
import RobotNavigation from "../features/robot/RobotNavigation";

import Error404Page from "./Error404Page";

function SearchFilesPage(props) {
  const { robotName } = useParams();
  const robotId = robotName.match(/(\d+)/) && robotName.match(/(\d+)/)[0];

  if (!robotId) {
    return <Error404Page />;
  }

  // This is to display calendar view for R&D units on staging URL as it is connected to correct backend
  const isStaging =
    window &&
    window.location &&
    window.location.hostname === "staging.app.novarctech.com";

  return (
    <>
      <RobotNavigation {...props} />
      {!isStaging && (robotId === "171" || robotId === "1910") ? (
        <RobotSearchFilesOld {...props} />
      ) : (
        <RobotSearchFiles {...props} />
      )}
    </>
  );
}

export default SearchFilesPage;
